// Количество попыток
export const EXERCISE_ATTEMPTS = 3

// Сколько раз упражнение можно выполнить
export const EXERCISE_DONE = 3
